import BSInfantMeatsProduct from 'models/BSInfantMeatsProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSInfantMeatsPackage from './BSInfantMeatsPackage'
import BSInfantNotice from 'views/BrandSpecific/Infant/BSInfantNotice'

const productOptions = {
  notice: <BSInfantNotice name="Infant Meats" />,
  packagingInfo: <BSInfantMeatsPackage />,
  productTitle: 'Brand Specific Infant Meats',
  model: BSInfantMeatsProduct,
  validCategories: ['13'],
  validSubCategories: ['001BS', '101BS'],
  brandSpecific: true,
}

const BSInfantMeats = () => <ProductForm product={productOptions} />

export default BSInfantMeats
